<template lang="pug">
    el-dialog(
      :title="title",
      width="95%",
      :visible.sync="visible",
      :modal-append-to-body="false",
      :append-to-body="true"
    )
      el-form(
        :model="ruleForm",
        :inline="false",
        :rules="rules",
        ref="ruleForm",
        label-width="120px"
      )
        el-card(shadow="never")
          div(slot="header")
            font(style="font-weight: bold; font-size: 18px") 比赛设置
          .labelStyle
            el-form-item(label="比赛名称:", prop="matchName")
              font {{ ruleForm.matchName }}
            el-form-item(label="主办方:", prop="userGroupName")
              font {{ ruleForm.userGroupName }}
            el-form-item(label="主办城市:", prop="cityName")
              font {{ ruleForm.provinceName }}&nbsp;{{ ruleForm.cityName }}
            el-form-item(label="比赛场地:", prop="venueAddress")
              font {{ ruleForm.venueAddress }}
            el-form-item(label="比赛类型:", prop="matchType")
              font(v-if="ruleForm.matchType === '1'") 分级公开赛
              font(v-if="ruleForm.matchType === '2'") 俱乐部赛
              font(v-if="ruleForm.matchType === '-1'") 青少年赛
            el-form-item(label="签位:", prop="applySize")
              font {{ ruleForm.applySize }}
            el-form-item(label="比赛项目:", prop="projectType")
              font(v-if="ruleForm.projectType === 1") 单打
              font(v-if="ruleForm.projectType === 2") 双打
            el-row(style="width: 100%")
              el-col(style="width: 50%")    
                el-form-item(label="最大添加场次:", prop="maxVenue")
                  font {{ ruleForm.maxVenue }}
              el-col(style="width: 50%")  
                el-form-item(label="成赛场次:", prop="establishVenue")
                  font {{ ruleForm.establishVenue }}
            el-form-item(label="联系电话:", prop="applySize")
              font {{ ruleForm.contactNumber }}
            el-form-item(label="报名时间:", prop="applyDate")
              font {{ ruleForm.matchSignStartTime }} 至 {{ ruleForm.matchSignEndTime }}
            el-form-item(label="比赛时间:", prop="matchStartTime")
              font {{ ruleForm.matchStartTime }}
            el-form-item(label="列表页图:", prop="imgList")
              el-input(v-model="ruleForm.imgList", v-show="false")
              img.avatar(
                v-if="listImageUrl",
                :src="listImageUrl",
                style="width: 256px; height: 190px"
              )
              el-alert(
                title="建议最小分辨率256×190,上传图片格式仅支持jpg,jpeg,png,大小不超过10M",
                effect="light",
                :closable="false",
                style="margin-top: 10px"
              )
            el-form-item(label="详情页图:", prop="imgDetailList")
              img.avatar(
                v-if="detailImageUrl",
                :src="detailImageUrl",
                style="width: 750px; height: 310px"
              )
              i.el-icon-plus.avatar-uploader-icon(
                v-else,
                style="width: 317px; height: 178px"
              )
            el-form-item(label="比赛简介:", prop="matchDescription")
              <div v-html="ruleForm.matchDescription"></div>
            el-form-item(label="报名须知:", prop="gameDescription")
              <div v-html="ruleForm.gameDescription"></div>
          el-form-item(label="比赛规程:", prop="imgDetailList")
            <div v-for="(item,index) in pdfs" style="display:flex">
              <div style="width:600px"> {{ item.fileName }}</div>
              <a v-if="item.loading == 100" :href="item.url" target="_blank" style="text-decoration: none;margin-left:50px" >下载</a>
            </div>
            </div>         
        br
        el-card(shadow="never")
          div(slot="header")
            font(style="font-weight: bold; font-size: 18px") 报名费用
          div
          el-row(style="padding-bottom: 15px", :span="24")
              el-col(:md="23", :sm="5")  
                el-form-item(label="报名费用:", prop="enrollFee")
                  el-input.width_ct(
                    v-model="ruleForm.enrollFee",
                    type="text",
                    maxlength="40",
                    disabled,
                    show-word-limit
                  )
                font.font_later 以关联子赛事为准！
        br
        el-card(shadow="never")
          div(slot="header")
            font(style="font-weight: bold; font-size: 18px") 自动退款设置
          div
            el-row(style="padding-bottom: 15px", :span="24")
              el-col(:md="23", :sm="5")
                el-form-item(label="设置自动退款:" prop="bench")
                   el-radio(v-model="ruleForm.autoRefund" :label="1" disabled) 是
                   el-radio(v-model="ruleForm.autoRefund" :label="0" disabled) 否
            el-row
              el-col(:span="8")
                el-form-item(label="距比赛开始小时", label-width="auto")
                  el-input-number(
                    v-model="ruleForm.refundTime",
                    :min="0",
                    :max="100000000",
                    :step="1"
                    placeholder="请填写时间"
                    disabled
                  )
                  font &nbsp;&nbsp;&nbsp;未达到已报满状态的比赛，参赛人员全额自动退费！
        br
        el-card(shadow="never", v-if="type == 'release'")
          div(slot="header")
            font(style="font-weight: bold; font-size: 18px") 审核意见
          div
            el-form-item(prop="verifyReason", label="填写审核意见:")
              el-input(
                v-model="ruleForm.verifyReason",
                type="textarea",
                :rows=5,
                resize="none"
              )
      span.dialog-footer(slot="footer", v-if="!type")
        el-button(@click="visible = false") 返 回
      //- //审核发布
      span.dialog-footer(slot="footer", v-if="type == 'release'")
        el-button(@click="releaseSubmit(20)", type="primary") 发 布
        el-button(@click="releaseSubmit(50)", type="danger") 拒 绝
        el-button(@click="visible = false") 取 消
      //- //支付弹窗组件
      zfpage(
        :openfree="visibleFee",
        :record="record",
        v-if="visibleFee",
        @zfsuccess="zfsuccess"
      )
    </template>
    <script>
    import zfpage from "../zfpage.vue";
    export default {
      components: {
        zfpage,
      },
      data() {
        return {
          pdfs: [],
          visibleFee: false,
          record: {},
          type: "",
          title: "查看详情",
          defaultImg: "",
          listImageUrl: "",
          detailImageUrl: "",
          tableData: [
            {
              dataName: "注册会员",
              type: 1,
              price: 0.0,
            },
            {
              dataName: "初始会员",
              type: 2,
              price: 0.0,
            },
            {
              dataName: "荣誉会员",
              type: 3,
              price: 0.0,
            },
          ],
          ruleForm: {
            id: null,
            ctId: "",
            matchName: "",
            orgId: "",
            city: "",
            province: "",
            placeId: "",
            ctType: "",
            applySize: "",
            projectType: null,
            level: "",
            bench: "1",
            applyDate: [],
            matchSignStartTime: "",
            matchSignEndTime: "",
            matchStartTime: "",
            imgList: "",
            gameDescription: "",
            matchDescription: "",
            imgDetailList: "",
            repeatSign: "0",
            genderLimit: "2",
            ageLimit: "",
            ageMinMen: undefined,
            ageMaxMen: undefined,
            ageMinWomen: undefined,
            ageMaxWomen: undefined,
            scoreMin: "",
            ctRefundList: [],
            byx1: "",
            verifyReason: "",
            minLevel: null, //级别限定
            maxLevel: null,
          },
          visible: false,
          rules: {
            // verifyReason: [
            //     { required: true, message: '审核意见不能为空!', trigger: 'blur' },
            //     {max: 200, message: '审核意见长度不能超过200个字符!'}
            // ]
          },
        };
      },
      filters: {
        dealAllowPlayOff(val) {
          let allowPlayOffData = [
            { label: "无附加赛", value: 0 },
            { label: "第三四名争夺季军", value: 1 },
          ];
          return allowPlayOffData.find((item) => item.value == val).label || "";
        },
      },
      methods: {
        zfsuccess(data) {
          this.visibleFee = false;
          console.log(data, 789);
          if (data == 1) {
            // this.$showLoading()
            this.$http({
              url: this.$http.adornUrl(`/frFranchiseFeeRecord/checkPayStatus`),
              method: "post",
              data: {
                busId: this.ruleForm.id,
                busType: 1,
                busCategory: 1,
              },
            }).then((data) => {
              if (data && data.code === 0) {
                this.visible = false;
                //缴费成功，直接发布
                this.updateState(2);
              } else {
                this.$message.error(data.msg);
              }
            });
          }
        },
        init(id, type) {
          console.log(id)
          this.title = "查看详情";
          this.ruleForm.id = id || null;
          this.visible = true;
          this.type = type;
          this.ruleForm.verifyReason = "";
          //回选
          if (this.ruleForm.id) {
            this.$http({
              url: this.$http.adornUrl(`/ctCompetition/selfSelection/getById/` + this.ruleForm.id),
              method: "get",
            }).then((data) => {
              if (data && data.code === 0) {
                this.pdfs = data.data.attachmentsList;
                this.ruleForm = data.data;
                this.listImageUrl = data.data.imgListUrl;
                this.detailImageUrl = data.data.imgDetailListUrl;
                this.ruleForm.applyDate = [];
                this.ruleForm.applyDate.push(data.data.matchSignStartTime);
                this.ruleForm.applyDate.push(data.data.matchSignEndTime);
                this.ruleForm.verifyReason = data.data.verifyReason;
                this.$nextTick(() => {
                  this.$refs["d2-quill"].Quill.options.readOnly = true
                  console.log(this.$refs["d2-quill"].Quill)
                  this.$refs["d2-quill"].Quill.pasteHTML(
                    data.data.matchDescription
                  );
                  this.$refs.gameDescription.Quill.pasteHTML(
                    data.data.gameDescription
                  );
                });
              }
            });
          }
        },
        releaseSubmit(type) {
          this.$refs["ruleForm"].validate((valid) => {
            if (valid) {
              if (type === 20) {
                this.$confirm("是否发布比赛?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(async () => {
                    //查询是否需要预缴加盟费，需要则先交费，不需要则直接发布
                    //status状态(0未缴费，1已缴费，2已退费)
                    if (this.record.type === 1 && this.record.status === 0) {
                      //仅未支付预缴费时，展示二维码支付页面
                      this.visibleFee = true;
                    } else {
                      //不是预缴费，则直接发布
                      this.updateState(type);
                    }
                    // this.updateState(type)
                  })
                  .catch(() => {
                    this.$message({
                      type: "info",
                      message: "已取消发布",
                    });
                  });
              } else if (type === 50) {
                this.updateState(type);
              }
            }
          });
        },
        //查询是否需要预缴加盟费，需要则先交费，不需要则直接发布
        finachiseFeePay() {
          this.$http({
            url: this.$http.adornUrl(`/frFranchiseFeeRecord/createQrCode`),
            method: "post",
            data: {
              busId: this.ruleForm.id,
              busType: 1,
              busCategory: 1,
            },
          }).then((data) => {
            if (data && data.code === 0) {
              this.record = data.record;
              console.log("record", this.record);
            } else {
              this.$message.error(data.msg);
            }
          });
        },
        // 数据处理
        CompetitionSelection(val, index) {
          if (val) {
            if (this.ruleForm.competitionMatchFormatList.length > 0) {
              if (val.length && index == 1) {
                return this.ruleForm.competitionMatchFormatList[0].matchFormat == 0
                  ? "淘汰附加赛"
                  : this.ruleForm.competitionMatchFormatList[0].matchFormat == 1
                  ? "小组循环赛"
                  : this.ruleForm.competitionMatchFormatList[0].matchFormat == 5
                  ? "淘汰赛"
                  : "";
              }
              if (val.length && index == 11) {
                return this.ruleForm.competitionMatchFormatList[0].groupNum;
              }
            }
    
            if (this.ruleForm.competitionMatchFormatList.length > 1) {
              if (val.length && index == 2) {
                // return this.ruleForm
                //     .competitionMatchFormatList[1]
                //     .matchFormat == 2
                //     ? '同名次小组循环赛'
                //     : this.ruleForm
                //             .competitionMatchFormatList[1]
                //             .matchFormat == 3
                //         ? '同名次淘汰附加赛'
                //         : this.ruleForm
                //                 .competitionMatchFormatList[1]
                //                 .matchFormat == 4
                //             ? '交叉淘汰附加赛'
                //             : ''
                let matchName = "";
                let matchFormat =
                  this.ruleForm.competitionMatchFormatList[1].matchFormat;
                switch (matchFormat) {
                  case 2:
                    matchName = "同名次小组循环赛";
                    break;
                  case 3:
                    matchName = "同名次淘汰附加赛";
                    break;
                  case 4:
                    matchName = "交叉淘汰附加赛";
                    break;
                  case 5:
                    matchName = "淘汰赛";
                    break;
                }
                return matchName;
              }
              if (val.length && index == 22) {
                return this.ruleForm.competitionMatchFormatList[1].crossNum;
              }
            }
          }
        },
        CompetitionSelection1(val, index) {
          console.log("--------", val, index);
          let matchName = "";
          if (val.length > 1 && index == 2) {
            if (val[1]["allowPlayOff"] === 0) {
              matchName = "无附加赛";
            }
            if (val[1]["allowPlayOff"] === 1) {
              matchName = "第三四名争夺季军";
            }
    
          }
          return matchName;
        },
        updateState(type) {
          if(type == 20) {
            this.$http({
            url: this.$http.adornUrl(`/ctCompetition/selfSelection/updateStatus`),
            method: "post",
            data: this.$http.adornParams({
              matchStatus: type,
              id: this.ruleForm.id,
              verifyReason: this.ruleForm.verifyReason
            }),
          }).then((data) => {
            if (data && data.code === 0) {
              this.$message({
                message: "审核成功",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            } else {
              this.$message.error(data.msg);
            }
          });
          }
          if(type == 50) {
            this.$http({
            url: this.$http.adornUrl(`/ctCompetition/selfSelection/updateStatus`),
            method: "post",
            data: this.$http.adornParams({
              matchStatus: type,
              id: this.ruleForm.id,
              eventCancelReason: this.ruleForm.verifyReason,
            }),
          }).then((data) => {
            if (data && data.code === 0) {
              this.$message({
                message: "拒绝操作成功",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            } else {
              this.$message.error(data.msg);
            }
          });
          }
        },
      },
    };
    </script>
    <style>
    .comecs .el-form-item__content {
      display: flex;
    }
    .el-table__header {
      width: 100% !important;
    }
    .el-table__body {
      width: 100% !important;
    }
    * {
      margin: 0;
    }
    </style>
    